/*--------------------------------------------------------------------------------------------------------------
 *  Copyright (c) insite-gmbh. All rights reserved.
 *  Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------------------------*/

import { Map } from '../../../../../@inax/common';

export interface MessageClass {
    id: number;
    name: string;
    display: string;
    ack: number;
    colors: Map<string>;
}